module.exports = "<input type=\"{{to.type||'text'}}\" class=\"c-input\" ng-model=\"model[options.key]\" />"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/formly/input.html
 ** module id = 539
 ** module chunks = 0
 **/